import { format } from "date-fns";

export function utcToDate(utc) {
	const d = new Date(utc ?? 0);
	return format(d, "dd.MM.yyyy");
}

export function utcToLocalDateTime(utc) {
	const d = new Date(utc ?? 0);
	return format(d, "dd.MM.yyyy HH:mm");
}

// Блокировка без причины не поддаётся аудиту: в Moderations остаётся только
// «кто и когда», а BlockList.reason пустой. Бэкенд такую заявку отклоняет —
// здесь та же проверка, чтобы модератор узнал об этом до отправки.
export const BLOCK_REASON_REQUIRED_TEXT = "Укажите причину блокировки";

export function normalizeBlockReason(reason) {
	return typeof reason === "string" ? reason.trim() : "";
}

export function isBlockReasonValid(reason) {
	return normalizeBlockReason(reason).length > 0;
}
